/**
 * Default issue slug used when the route is hit without an explicit `:slug`
 * (e.g. `/quarterly` → latest issue). Mirrors the S3 object key layout
 * `magazine/{slug}/filescan-quarterly-{slug}.pdf`.
 */
export const DEFAULT_QUARTERLY_SLUG = '2026-summer'

/**
 * Consent copy version recorded alongside the marketing-consent flag.
 * Bump whenever the consent wording below changes so stored leads stay auditable.
 */
export const CONSENT_TEXT_VERSION = '2026-07'

/**
 * Vertical / industry options for the lead-capture gate.
 */
export const QUARTERLY_VERTICALS: { value: string; label: string }[] = [
  { value: 'critical-infrastructure', label: 'Critical Infrastructure' },
  { value: 'financial-services', label: 'Financial Services' },
  { value: 'government', label: 'Government & Public Sector' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'technology', label: 'Technology & Software' },
  { value: 'energy-utilities', label: 'Energy & Utilities' },
  { value: 'education', label: 'Education' },
  { value: 'other', label: 'Other' },
]
